@if (mainContent) {
  <app-modal
    [modalTitle]="modalTitleKey"
    [mainContentTemplate]="mainContent"
    (closed)="activeModal.dismiss()"
  ></app-modal>
}

<ng-template #mainContent>
  <div class="text-center py-3">
    <div
      class="spinner-border text-primary mb-3"
      role="status"
      aria-hidden="true"
    ></div>
    <p class="mb-3">
      {{ "registrationWizard.veriffWaiting.message" | translate }}
    </p>
    <p class="fw-semibold small text-uppercase text-muted mb-1">
      {{ "registrationWizard.veriffWaiting.statusLabel" | translate }}
    </p>
    <p class="mb-0 text-break">{{ statusText() }}</p>
  </div>
</ng-template>
